import { routeCreator } from "../../../helpers/routing/routeCreator";
import Form from "../pages/form";





export const ROUTE_PAGE_REPORTS = routeCreator(Form, '/reports', 'Reports', 'page.registrations')


const router = {
    ROUTE_PAGE_REPORTS,
}

export default router